module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/extend.js
// module id = 745
// module chunks = 0